export default __webpack_public_path__ + "static/media/project_visual_16.cb22a6fb.jpg";